import { useState, useEffect } from 'react'
import type { ModelsData, ModelGroups, ModelData } from '../types'
import { modelsData, modelGroups } from '../data/modelData-new'

export const useModelData = () => {
  const [modelsDataState, setModelsDataState] = useState<ModelsData>({})
  const [modelGroupsState, setModelGroupsState] = useState<ModelGroups>({})
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Load the real model data
    const loadData = async () => {
      try {
        setModelsDataState(modelsData)
        setModelGroupsState(modelGroups)
        setIsLoading(false)
      } catch (error) {
        console.error('Error loading model data:', error)
        setIsLoading(false)
      }
    }

    loadData()
  }, [])

  // Function to add a new model
  const addModel = (newModel: ModelData) => {
    const customGroupKey = 'custom'
    
    console.log('Adding model to group:', customGroupKey)
    console.log('Model data:', newModel)
    
    // Add to models data in custom group
    setModelsDataState(prev => {
      const existingCustomGroup = prev[customGroupKey] || {}
      
      const newModelsData = {
        ...prev,
        [customGroupKey]: {
          ...existingCustomGroup,
          [newModel.id!]: newModel
        }
      }
      
      console.log('Updated modelsData:', newModelsData)
      return newModelsData
    })

    // Add to model groups if custom group doesn't exist
    setModelGroupsState(prev => {
      const customGroupName = 'Modele Niestandardowe'
      if (!prev[customGroupName]) {
        const newModelGroups = {
          ...prev,
          [customGroupName]: customGroupKey
        }
        console.log('Updated modelGroups:', newModelGroups)
        return newModelGroups
      }
      return prev
    })

    console.log('Model successfully added to the system:', newModel.name)
  }

  return {
    modelsData: modelsDataState,
    modelGroups: modelGroupsState,
    isLoading,
    addModel
  }
}
